import React from 'react'

function ListingSaleComp() {
    return (
        <section id="listing-sale-comp">
            <div className='container my-5'>
                <div className='row' >
                    <h1 className='text-primary fw-bold text-start'>Our Listing</h1>
                    <div id='midlands-tagaytay' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <h4 className='text-primary text-start'>House & Lot in Midlands (inside Golf Course), Tagaytay City</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Tranca, Tagaytay</small></p>
                            <div id="MidlandTagaytayUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                </div>
                                <div className=''>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay1.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay2.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Family Room</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay3.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dining and Kitchen</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay4.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay6.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>House Front View</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay7.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay8.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Room</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/MidlandTagaytay/MidlandTagaytay9.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Lounge Room</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#MidlandTagaytayUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='text-start'>
                                <b>Description:</b>
                                <ul>
                                    <li>4 Bedroom</li>
                                    <li>4 Toilet and Bath</li>
                                    <li>Floor: 353 sq.m. (3810.42.20 sq.ft) </li>
                                    <li>Lot: 368 sq.m. (3961.12 sq.ft) </li>
                                    <li>2 Storey</li>
                                    <li>Inside Golf Course</li>
                                </ul>

                                <b>Additional Details:</b>
                                <ul>
                                    <li>with family room on second level</li>
                                    <li>Master's Bedroom with own terrace</li>
                                    <li>Master's Toilet and Bath with bathtub, his & hers lavatory</li>
                                    <li>Furniture may be negotiated</li>
                                    <li>inclusive of proprietary share/membership <br />to Tagaytay Midlands Golf Club</li>
                                </ul>

                                <b>Others Details:</b>
                                <p>
                                    <small>
                                        Shows off the loveliest landscapes in over 9 hectares of land.
                                        A community of contemporary tropical homes, underground utilities
                                        surrounded by the fairways highlighted  by calming natural surroundings
                                        crisp and pleasing weather. A safe, gated community with 24-hour
                                        independent security, abundant water supply, 24-hour medical emergency responder,
                                        fire-fighting teams and 100% In-house emergency power supply. The Golf Course also features
                                        landscaping and full housekeeping services available.
                                    </small>
                                </p>

                                <div class="d-flex justify-content-start">
                                    <p class="text-start text-white m-0 px-2 border border-info border-3 rounded-pill bg-info">
                                        <small><b>Php 31, 500, 000.00</b></small>
                                    </p>
                                </div>
                                <p>
                                    <small>
                                        Available for Viewing
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-sale/midlands-tagaytay'>See More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='soma-taguig' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <h4 className='text-primary text-start'>3 Bedroom with Parking in South of Market, Taguig City</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> South of Market BGC, Taguig</small></p>
                            <div id="SomaTaguigUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                    <button type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide-to="8" aria-label="Slide 9"></button>
                                </div>
                                <div className=''>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig1.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Lobby Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig2.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Concierge</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig3.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Elevetor</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig4.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig5.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig6.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dining Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig7.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Master Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig8.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Cabinets</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/SomaTaguig/SomaTaguig9.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Room</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#SomaTaguigUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='text-start'>
                                <b>Description:</b>
                                <ul>
                                    <li>3 Bedroom</li>
                                    <li>2 Toilet and Bath</li>
                                    <li>116 sqm (1248.61 sqft)</li>
                                    <li>Maid's Room with own Toilet and Bath</li>
                                    <li>1 Parking Slot</li>
                                </ul>

                                <b>Furnished included:</b>
                                <ul>
                                    <li>bedroom furniture</li>
                                    <li>dining set</li>
                                    <li>refrigerator</li>
                                    <li>washer and dryer</li>
                                    <li>water dispenser</li>
                                    <li>full kitchen with 4-burner electric range with oven</li>
                                </ul>

                                <b>Others Details:</b>
                                <p>

                                    <small>
                                        <ul>
                                            <li>Master bedroom has king size bed & mattress plus custom clothes closet </li>
                                            <li>Guest room is without bed, but with closet</li>
                                            <li>Guest room includes bed & mattress and closet</li>
                                            <li>Master Bedroom bath and Main Bathroom <br />are equipped with hot water for shower</li>
                                            <li>3 Bath (adjacent to kitchen), the shower is not equipped with hot water.</li>
                                        </ul>
                                        Practically, this Unit is ready for move-in.
                                        New interior paint throughout, and new flooring.
                                        Never been lived in since renovation last December.
                                        Beautiful unobstructed view of Makati skyline from master bedroom
                                    </small>
                                </p>

                                <div class="d-flex justify-content-start">
                                    <p class="text-start text-white m-0 px-2 border border-info border-3 rounded-pill bg-info">
                                        <small><b>Php 20, 370, 000.00</b></small>
                                    </p>
                                </div>
                                <p>
                                    <small>
                                        Available for Viewing
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-sale/soma-taguig'>See More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='asteria-paranaque' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <h4 className='text-primary text-start'>2 Bedroom with Balcony and Parking in Asteria Residences, Parañaque City</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> San Isidro Sucat, Paranaque</small></p>
                            <div id="AsteriaParanaqueUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="8" aria-label="Slide 9"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="9" aria-label="Slide 10"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="10" aria-label="Slide 11"></button>
                                    <button type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide-to="11" aria-label="Slide 12"></button>
                                </div>
                                <div className=''>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque1.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque2.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque3.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dining Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque6.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>

                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque9.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Big Balcony</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque10.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque11.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bathroom Sink</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque12.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bathroom Cabinets</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque13.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Water Heater</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/AsteriaParanaque14.webp"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Drying Cage</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#AsteriaParanaqueUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='text-start'>
                                <b>Description:</b>
                                <ul>
                                    <li>2 Bedroom</li>
                                    <li>1 Toilet and Bath</li>
                                    <li>61 sqm (656.599 sqft) </li>
                                    <li>1 Parking Slot</li>
                                </ul>

                                <b>Other Features:</b>
                                <ul>
                                    <li>1 drying cage </li>
                                    <li>1 utility area </li>
                                    <li>1 washing area</li>
                                    <li>Big Balcony</li>
                                </ul>

                                <b>Others Details:</b>
                                <p>Vicinity
                                    <br />
                                    <small>
                                        The project is located in San Antonio Valley 2, where houses surrounding the project
                                        bring out a sense of quiet and calm. Just a few minutes away, you find many establishments
                                        in Parañaque - from malls to supermarkets and restaurants.
                                    </small>
                                    <br />
                                    <br />
                                    Ownership
                                    <br />
                                    <small>
                                        Freehold or perpetual ownership. Foreigners can buy into the complex as 40% of total units in is allowed for foreign buyers.
                                    </small>
                                </p>

                                <div class="d-flex justify-content-start">
                                    <p class="text-start text-white m-0 px-2 border border-info border-3 rounded-pill bg-info">
                                        <small><b>Php 5, 995, 000.00</b></small>
                                    </p>
                                </div>
                                <p>
                                    <small>
                                        Available for Viewing
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-sale/asteria-paranaque'>See More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </section>
    )
}

export default ListingSaleComp